import { useState } from 'react';

import {
  TextareaWithConfirm,
  DateInputWithConfirm,
  InputWithConfirm,
  getStringFromDate,
  getDateFromString,
  ContinueButton
} from 'shared-components';

import { VQ } from '../../../../../store/student/types';
import { IBorderRefusal, IDate } from '../../../../../types';
import { isValidDate } from '../../../../../utilities/validation';

interface IProps {
  index: number;

  refusalDate: string;
  airport: string;
  reason: string;
  reference: string;

  onSaveAndClose: (refusal: IBorderRefusal) => void;
}

const BorderRefusals = (props: IProps) => {
  const { index, onSaveAndClose } = props;
  const [dRefusal, setDRefusal] = useState(() => getDateFromString(props.refusalDate));
  const [dRefusalError, setDRefusalError] = useState('');
  const [airport, setAirport] = useState(props.airport);
  const [reason, setReason] = useState(props.reason);
  const [reference, setReference] = useState(props.reference);

  const saveAndClose = () => {
    onSaveAndClose({
      refusalDate: getStringFromDate(dRefusal),
      airport,
      reason,
      reference
    });
  };

  const handleOnSaveAndCloseClick = () => {
    saveAndClose();
  };

  const validateDate = (dateValue: IDate): string => {
    const { YYYY, DD, MM } = dateValue;

    if (YYYY && DD && MM) {
      const isValid = isValidDate(dateValue);
      if (!isValid) {
        return "Doesn't look like a valid date";
      } else {
        return '';
      }
    }

    return '';
  };

  const complete =
    dRefusal.DD !== null &&
    dRefusal.MM !== null &&
    dRefusal.YYYY !== null &&
    dRefusalError === '' &&
    airport !== '' &&
    reason !== '' &&
    reference !== '';

  return (
    <>
      <DateInputWithConfirm
        key={`${VQ.BORDER_REFUSAL_DATE}-${index}`}
        id={`${VQ.BORDER_REFUSAL_DATE}-${index}`}
        label={`Date of refusal`}
        value={dRefusal}
        errorText={dRefusalError}
        onChangeDD={(evt: any) => setDRefusal({ ...dRefusal, DD: evt.target.value })}
        onChangeMM={(evt: any) => setDRefusal({ ...dRefusal, MM: evt.target.value })}
        onChangeYY={(evt: any) => setDRefusal({ ...dRefusal, YYYY: evt.target.value })}
        onBlur={(evt: any) => setDRefusalError(validateDate(dRefusal))}
      />

      <InputWithConfirm
        key={`${VQ.BORDER_REFUSAL_AIRPORT}-${index}`}
        id={`${VQ.BORDER_REFUSAL_AIRPORT}-${index}`}
        value={airport}
        label={`Port or airport`}
        onChange={(evt: any) => {
          setAirport(evt.currentTarget.value);
        }}
      />

      <TextareaWithConfirm
        key={`${VQ.BORDER_REFUSAL_REASON}-${index}`}
        id={`${VQ.BORDER_REFUSAL_REASON}-${index}`}
        value={reason}
        label={`Reason`}
        onChange={(evt: any) => {
          setReason(evt.currentTarget.value);
        }}
      />

      <InputWithConfirm
        key={`${VQ.BORDER_REFUSAL_REFERENCE}-${index}`}
        id={`${VQ.BORDER_REFUSAL_REFERENCE}-${index}`}
        value={reference}
        label={`Reference number`}
        onChange={(evt: any) => {
          setReference(evt.currentTarget.value);
        }}
      />

      <ContinueButton index={index} complete={complete} handleOnSaveAndCloseClick={handleOnSaveAndCloseClick} />
    </>
  );
};

export default BorderRefusals;
